import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';

import { AddCoachMeetingDialogComponent } from 'dialog/add-coach-meeting-dialog/add-coach-meeting-dialog.component';
import { IUser } from 'user/user';

import { CoacheeProfileController } from './coachee-profile.controller';
import { CoacheeProfileStore } from './coachee-profile.store';

@Component({
	selector: 'spr-coachee-profile',
	templateUrl: './coachee-profile.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoacheeProfileStore, CoacheeProfileController],
	host: {
		class: 'h-full flex flex-col items-stretch relative',
	},
})
export class CoacheeProfileComponent {
	public coachee$: Observable<IUser>;

	constructor(
		private _dialogService: DialogService,
		private _translateService: TranslateService,
		public controller: CoacheeProfileController,
		@Inject(DOCUMENT) private _document: Document
	) {
		this.coachee$ = controller.coachee$;
	}

	public onActiveIndexChange(index: number) {
		this.controller.updateActiveTabIndex(index);
	}

	public onBottomReached() {
		this.controller.triggerBottomReached();
	}

	public onAddMeetingClick(coachee: IUser) {
		this._dialogService.open(AddCoachMeetingDialogComponent, {
			header: this._translateService.instant(
				'presentation.app.common.dialog.addCoachMeeting.title',
				{ name: coachee.name }
			),
			data: { coacheeId: coachee.id },
			style: { maxWidth: '80vw' },
			dismissableMask: true,
			width: '400px',
			modal: true,
		});
	}

	public onSendEmailClick(email: string): void {
		this._document.location.href = `mailto:${email}`;
	}
}
